import { render, staticRenderFns } from "./BulkAttestation.vue?vue&type=template&id=25b92797&scoped=true&"
import script from "./BulkAttestation.vue?vue&type=script&lang=js&"
export * from "./BulkAttestation.vue?vue&type=script&lang=js&"
import style0 from "./BulkAttestation.vue?vue&type=style&index=0&id=25b92797&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b92797",
  null
  
)

export default component.exports